// import { useEffect, useMemo, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import styles from "./VenuePlanner3D.module.css";

// import PageMeta from "./Breadcrumb/PageMeta";
// import VenueHero from "./VenueHero";
// import VenuePageSecondNav from "./VenuePageSecondNav/VenuePageSecondNav";
// import VenuePlannerSkeleton from "./Loading/VenuePlannerSkeleton";
// import ErrorState from "./Loading/ErrorState";
// import EmptyState from "./Loading/EmptyState";

// import StateSelector from "./StateSelector";
// import CitySelector from "./CitySelector";
// import GlobalSearch from "./GlobalSearch/GlobalSearch";

// import HotelGrid from "./HotelGrid/HotelGridview";
// import HotelList from "./HotelGrid/HotelListview";
// import HotelViewToggle from "./HotelGrid/HotelViewToggle";
// import HotelMap from "./HotelGrid/HotelMapview";

// import MiceHighlights from "../Mice Vertical/MiceHighlight/MiceHighlights";
// import CTASection from "../CTASection/CTASection";
// import FeaturedHotels from "./FeaturedHotels/FeaturedHotels";
// // import FAQSection from "../Contact/MainFAQSEction/FAQSection";
// import HotelComparison from "./HotelComparison/HotelComparison";

// import { getVenuePlannerData } from "./venuePlannerApi";
// import "leaflet/dist/leaflet.css";

// export default function VenuePlanner3D() {
//   const navigate = useNavigate();
//   const [hotels, setHotels] = useState([]);
//   const [comparisonHotels, setComparisonHotels] = useState([]);
//   const [hotelViewMode, setHotelViewMode] = useState("grid");

//   const [searchParams, setSearchParams] = useSearchParams();

//   const [selectedState, setSelectedState] = useState(
//     searchParams.get("state") || ""
//   );

//   const [selectedCity, setSelectedCity] = useState(
//     searchParams.get("city") || ""
//   );

//   const [searchTerm, setSearchTerm] = useState("");

//   // Track a specific hotel selected from search results.
//   const [selectedSearchHotel, setSelectedSearchHotel] = useState(null);

//   const [activeSection, setActiveSection] = useState(
//     window.location.hash.replace("#", "") || "featured"
//   );

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     loadVenueData();
//   }, []);

//   const loadVenueData = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const response = await getVenuePlannerData();

//       console.log("Venue Data:", response);
//       setHotels(response);
//     } catch (err) {
//       console.error(err);
//       setError("Unable to load venue data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Manually selecting a state clears the specific hotel selection.
//   const handleStateChange = (state) => {
//     setSelectedState(state);
//     setSelectedCity("");
//     setSelectedSearchHotel(null);

//     if (state) {
//       setSearchParams({ state });
//     } else {
//       setSearchParams({});
//     }
//   };

//   // Manually selecting a city clears the specific hotel selection.
//   const handleCityChange = (city) => {
//     setSelectedCity(city);
//     setSelectedSearchHotel(null);

//     if (city) {
//       setSearchParams({
//         state: selectedState,
//         city,
//       });
//     } else if (selectedState) {
//       setSearchParams({ state: selectedState });
//     } else {
//       setSearchParams({});
//     }
//   };

//   // Filter hotels according to the selected location.
//   const filteredHotels = useMemo(
//     () =>
//       hotels.filter(
//         (hotel) =>
//           (!selectedState || hotel.state === selectedState) &&
//           (!selectedCity || hotel.city === selectedCity)
//       ),
//     [hotels, selectedState, selectedCity]
//   );

//   // A direct hotel search takes priority over location filtering.
//   const displayedHotels = selectedSearchHotel
//     ? [selectedSearchHotel]
//     : filteredHotels;

//   const handleSectionChange = (section) => {
//     setActiveSection(section);

//     window.history.pushState(
//       null,
//       "",
//       `${window.location.pathname}${window.location.search}#${section}`
//     );
//   };

//   // Select one specific hotel from GlobalSearch.
//   const handleSearchHotelSelect = (hotel) => {
//     const state = hotel.state || "";
//     const city = hotel.city || "";

//     setSelectedSearchHotel(hotel);
//     setSelectedState(state);
//     setSelectedCity(city);
//     setSearchTerm("");

//     if (state && city) {
//       setSearchParams({ state, city });
//     } else if (state) {
//       setSearchParams({ state });
//     } else {
//       setSearchParams({});
//     }
//   };

//   // Return to the full location-based hotel results.
//   const handleClearSearchHotel = () => {
//     setSelectedSearchHotel(null);
//   };

//   return (
//     <main className={styles.page}>
//       <PageMeta
//         title="Venue Planner | Atlas Travel House"
//         description="Discover premium hotels, ballrooms and event venues across India with Atlas Travel House Venue Planner."
//       />

//       <VenueHero />

//       {loading ? (
//         <section>
//           <VenuePlannerSkeleton />
//         </section>
//       ) : error ? (
//         <section>
//           <ErrorState onRetry={loadVenueData} />
//         </section>
//       ) : (
//         <>
//           <VenuePageSecondNav
//             activeSection={activeSection}
//             onSectionChange={handleSectionChange}
//             comparisonCount={comparisonHotels.length}
//           />

//           <section className={styles.venueContent}>
//             {/* Featured Venues */}
//             {activeSection === "featured" && (
//               <section
//                 id="featured"
//                 className={styles.featuredSection}
//               >
//                 <FeaturedHotels
//                   hotels={hotels}
//                   viewMode={hotelViewMode}
//                   onViewChange={setHotelViewMode}
//                   comparisonHotels={comparisonHotels}
//                   setComparisonHotels={setComparisonHotels}
//                 />
//               </section>
//             )}

//             {/* Explore Hotels: Search + Location Selectors */}
//             {activeSection === "hotels" && (
//               <section
//                 id="hotels"
//                 className={styles.hotelFinderSection}
//               >
//                 <section className={styles.searchSection}>
//                   {/* <div className={styles.placeholder}>
//                     <h2>Explore Hotels</h2>
//                     <p>
//                       Search for a specific hotel or browse
//                       hotels by location.
//                     </p>
//                   </div> */}

//                   {/* <GlobalSearch
//                     hotels={hotels}
//                     searchTerm={searchTerm}
//                     setSearchTerm={setSearchTerm}
//                     onHotelSelect={handleSearchHotelSelect}
//                   /> */}
//                   <GlobalSearch
//   hotels={hotels}
//   searchTerm={searchTerm}
//   setSearchTerm={setSearchTerm}
//   onHotelSelect={(hotel) => {
//     if (hotel.slug) {
//       navigate(
//         `/venue-planner/hotel/${hotel.slug}`
//       );
//     }
//   }}
// />
//                 </section>

//                 {/* Browse by Location */}
//                 <section className={styles.filters}>
//                   <StateSelector
//                     hotels={hotels}
//                     selectedState={selectedState}
//                     onStateChange={handleStateChange}
//                   />

//                   {selectedState && (
//                     <CitySelector
//                       hotels={hotels}
//                       selectedState={selectedState}
//                       selectedCity={selectedCity}
//                       onCityChange={handleCityChange}
//                     />
//                   )}
//                 </section>

//                 {/* Hotel Results */}
//                 <section className={styles.hotelSection}>
//                   {(
//                     selectedSearchHotel ||
//                     (selectedCity && filteredHotels.length > 0)
//                   ) ? (
//                     <>
//                       <div className={styles.hotelViewHeader}>
//                         <div>
//                           <h2>
//                             {selectedSearchHotel
//                               ? selectedSearchHotel.name
//                               : `Hotels in ${selectedCity}`}
//                           </h2>

//                           <span>
//                             {displayedHotels.length}{" "}
//                             {displayedHotels.length === 1
//                               ? "Hotel"
//                               : "Hotels"}
//                           </span>
//                         </div>

//                         <HotelViewToggle
//                           viewMode={hotelViewMode}
//                           onChange={setHotelViewMode}
//                         />
//                       </div>

//                       {/* Clear specific hotel selection */}
//                       {selectedSearchHotel && (
//                         <button
//                           type="button"
//                           onClick={handleClearSearchHotel}
//                           className={styles.clearHotelSelection}
//                         >
//                           <span aria-hidden="true">×</span>
//                           Show all hotels in {selectedCity || selectedState || "selected location"}
//                         </button>
//                       )}

//                       {hotelViewMode === "grid" && (
//                         <HotelGrid
//                           hotels={displayedHotels}
//                           comparisonHotels={comparisonHotels}
//                           setComparisonHotels={setComparisonHotels}
//                         />
//                       )}

//                       {hotelViewMode === "list" && (
//                         <HotelList
//                           hotels={displayedHotels}
//                           comparisonHotels={comparisonHotels}
//                           setComparisonHotels={setComparisonHotels}
//                         />
//                       )}

//                       {hotelViewMode === "map" && (
//                         <HotelMap
//                           hotels={displayedHotels}
//                           comparisonHotels={comparisonHotels}
//                           setComparisonHotels={setComparisonHotels}
//                         />
//                       )}
//                     </>
//                   ) : (
//                     <EmptyState />
//                   )}
//                 </section>
//               </section>
//             )}

//             {/* Compare Hotels */}
//             {activeSection === "compare" && (
//               <section
//                 id="compare"
//                 className={styles.compareSection}
//               >
//                 <HotelComparison
//                   hotels={hotels}
//                   selectedHotels={comparisonHotels}
//                   setSelectedHotels={setComparisonHotels}
//                 />
//               </section>
//             )}
//           </section>

//           <section className={styles.body}>
//             <CTASection
//               heading="Can't Find the Right Venue?"
//               description="Tell us your event requirements, preferred location, and guest count. Our venue experts will shortlist the best hotels and ballrooms tailored to your event."
//               buttonText="Speak to Our MICE Expert"
//               buttonLink="/contact"
//             />

//             <section id="mice-highlights">
//               <MiceHighlights />
//             </section>
// {/* 
//             <FAQSection
//               mainCategory="event"
//               subcategory="Hotels"
//               showSearch={true}
//             /> */}
//           </section>
//         </>
//       )}
//     </main>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styles from "./VenuePlanner3D.module.css";
import {  useLocation,} from "react-router-dom";
import PageMeta from "./Breadcrumb/PageMeta";
import VenueHero from "./VenueHero";
import VenuePageSecondNav from "./VenuePageSecondNav/VenuePageSecondNav";
import VenuePlannerSkeleton from "./Loading/VenuePlannerSkeleton";
import ErrorState from "./Loading/ErrorState";
import EmptyState from "./Loading/EmptyState";

import StateSelector from "./StateSelector";
import CitySelector from "./CitySelector";
import GlobalSearch from "./GlobalSearch/GlobalSearch";

import HotelGrid from "./HotelGrid/HotelGridview";
import HotelList from "./HotelGrid/HotelListview";
import HotelViewToggle from "./HotelGrid/HotelViewToggle";
import HotelMap from "./HotelGrid/HotelMapview";

import MiceHighlights from "../Mice Vertical/MiceHighlight/MiceHighlights";
import CTASection from "../CTASection/CTASection";
import FeaturedHotels from "./FeaturedHotels/FeaturedHotels";
// import FAQSection from "../Contact/MainFAQSEction/FAQSection";
import HotelComparison from "./HotelComparison/HotelComparison";
import HotelSuggestionForm from "./HotelSuggestions/HotelSuggestionForm";

import { getVenuePlannerData } from "./venuePlannerApi";
import "leaflet/dist/leaflet.css";

export default function VenuePlanner3D() {
  const navigate = useNavigate();
  const [hotels, setHotels] = useState([]);
  const [comparisonHotels, setComparisonHotels] = useState([]);
  const [comparisonStateInitialized, setComparisonStateInitialized] =
  useState(false);
  const [hotelViewMode, setHotelViewMode] = useState("grid");

  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedState, setSelectedState] = useState(
    searchParams.get("state") || ""
  );

  const [selectedCity, setSelectedCity] = useState(
    searchParams.get("city") || ""
  );

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedSearchHotel, setSelectedSearchHotel] = useState(null);

  
// const [activeSection, setActiveSection] = useState(() => {
//   const section = window.location.hash.replace("#", "");
//   return ["featured", "hotels", "compare"].includes(section)
//     ? section
//     : "featured";
// });
const [activeSection, setActiveSection] = useState(() => {
  const section = window.location.hash.replace("#", "");

  if (["featured", "hotels", "compare"].includes(section)) {
    return section;
  }

  const params = new URLSearchParams(window.location.search);
 if (params.has("compare")) {
  return "compare";
}
  if (params.has("state") || params.has("city")) {
    return "hotels";
  }

  return "featured";
});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    loadVenueData();
  }, []);

  const loadVenueData = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getVenuePlannerData();

      console.log("Venue Data:", response);
      setHotels(response);
    } catch (err) {
      console.error(err);
      setError("Unable to load venue data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (loading || comparisonStateInitialized) return;

  const params = new URLSearchParams(window.location.search);
  const compareSlugs = (params.get("compare") || "")
    .split(",")
    .filter(Boolean);

  const restoredHotels = compareSlugs
    .map((slug) => hotels.find((hotel) => hotel.slug === slug))
    .filter(Boolean)
    .slice(0, 4);

  setComparisonHotels(restoredHotels);
  setComparisonStateInitialized(true);
}, [hotels, loading, comparisonStateInitialized]);
useEffect(() => {
  if (!comparisonStateInitialized) return;

  const params = new URLSearchParams(window.location.search);

  const slugs = comparisonHotels
    .map((hotel) => hotel.slug)
    .filter(Boolean);

  if (slugs.length > 0) {
    params.set("compare", slugs.join(","));
  } else {
    params.delete("compare");
  }

  const search = params.toString();
  const hash = activeSection === "compare"
    ? "#compare"
    : window.location.hash;

  const nextUrl =
    `${window.location.pathname}` +
    `${search ? `?${search}` : ""}` +
    hash;

  const currentUrl =
    `${window.location.pathname}` +
    `${window.location.search}` +
    `${window.location.hash}`;

  if (nextUrl !== currentUrl) {
    navigate(nextUrl, { replace: true, preventScrollReset: true });
  }
}, [
  comparisonHotels,
  comparisonStateInitialized,
  activeSection,
  navigate,
]);
  
const handleStateChange = (state) => {
  setSelectedState(state);
  setSelectedCity("");
  setSelectedSearchHotel(null);

  const params = new URLSearchParams();

  if (state) {
    params.set("state", state);
  }

  const query = params.toString();

  navigate(
    `${window.location.pathname}${query ? `?${query}` : ""}#hotels`,
    { preventScrollReset: true }
  );

  setActiveSection("hotels");
};

const handleCityChange = (city) => {
  setSelectedCity(city);
  setSelectedSearchHotel(null);

  const params = new URLSearchParams();

  if (selectedState) {
    params.set("state", selectedState);
  }

  if (city) {
    params.set("city", city);
  }

  const query = params.toString();

  navigate(
    `${window.location.pathname}${query ? `?${query}` : ""}#hotels`,
    { preventScrollReset: true }
  );

  setActiveSection("hotels");
};

  const filteredHotels = useMemo(
    () =>
      hotels.filter(
        (hotel) =>
          (!selectedState || hotel.state === selectedState) &&
          (!selectedCity || hotel.city === selectedCity)
      ),
    [hotels, selectedState, selectedCity]
  );

  const displayedHotels = selectedSearchHotel
    ? [selectedSearchHotel]
    : filteredHotels;

// const location = useLocation();

// useEffect(() => {
//   const section = location.hash.replace("#", "");

//   setActiveSection(
//     ["featured", "hotels", "compare"].includes(section)
//       ? section
//       : "featured"
//   );

//   setSelectedState(searchParams.get("state") || "");
//   setSelectedCity(searchParams.get("city") || "");
// }, [location.pathname, location.search, location.hash, searchParams]);

const location = useLocation();

useEffect(() => {
  const section = location.hash.replace("#", "");
  const validSections = ["featured", "hotels", "compare"];

  if (validSections.includes(section)) {
    setActiveSection(section);
  } else if (
    searchParams.has("state") ||
    searchParams.has("city")
  ) {
    setActiveSection("hotels");
  } else {
    setActiveSection("featured");
  }

  setSelectedState(searchParams.get("state") || "");
  setSelectedCity(searchParams.get("city") || "");
}, [
  location.pathname,
  location.search,
  location.hash,
  searchParams,
]);
const handleSectionChange = (section) => {
  if (!["featured", "hotels", "compare"].includes(section)) return;

  setActiveSection(section);

  navigate(
    `${window.location.pathname}${window.location.search}#${section}`,
    { preventScrollReset: true }
  );

  const target = document.getElementById(section);

  if (target) {
    const navOffset = 90;
    const targetPosition =
      target.getBoundingClientRect().top +
      window.scrollY -
      navOffset;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  }
};
  
  const handleSearchHotelSelect = (hotel) => {
    const state = hotel.state || "";
    const city = hotel.city || "";

    setSelectedSearchHotel(hotel);
    setSelectedState(state);
    setSelectedCity(city);
    setSearchTerm("");

    if (state && city) {
      setSearchParams({ state, city });
    } else if (state) {
      setSearchParams({ state });
    } else {
      setSearchParams({});
    }
  };

  const handleClearSearchHotel = () => {
    setSelectedSearchHotel(null);
  };

  return (
    <main className={styles.page}>
      <PageMeta
        title="Venue Planner | Atlas Travel House"
        description="Discover premium hotels, ballrooms and event venues across India with Atlas Travel House Venue Planner."
      />

      <VenueHero />

      {loading ? (
        <section>
          <VenuePlannerSkeleton />
        </section>
      ) : error ? (
        <section>
          <ErrorState onRetry={loadVenueData} />
        </section>
      ) : (
        <>
          <VenuePageSecondNav
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
            comparisonCount={comparisonHotels.length}
          />

          <section className={styles.venueContent}>
            {/* Featured Venues */}
            {activeSection === "featured" && (
              <section
                id="featured"
                className={styles.featuredSection}
              >
                <FeaturedHotels
                  hotels={hotels}
                  viewMode={hotelViewMode}
                  onViewChange={setHotelViewMode}
                  comparisonHotels={comparisonHotels}
                  setComparisonHotels={setComparisonHotels}
                />
              </section>
            )}

            {/* Explore Hotels: Search + Location Selectors */}
            {activeSection === "hotels" && (
              <section
                id="hotels"
                className={styles.hotelFinderSection}
              >
                <section className={styles.searchSection}>
                           
                  <GlobalSearch
  hotels={hotels}
  searchTerm={searchTerm}
  setSearchTerm={setSearchTerm}
  onHotelSelect={(hotel) => {
  if (hotel.slug) {
    navigate(`/venue-planner/hotel/${hotel.slug}`, {
      state: {
        from: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      },
    });
  }
}}
/>
                </section>

                {/* Browse by Location */}
                <section className={styles.filters}>
                  <StateSelector
                    hotels={hotels}
                    selectedState={selectedState}
                    onStateChange={handleStateChange}
                  />

                  {selectedState && (
                    <CitySelector
                      hotels={hotels}
                      selectedState={selectedState}
                      selectedCity={selectedCity}
                      onCityChange={handleCityChange}
                    />
                  )}
                </section>

                {/* Hotel Results */}
                <section className={styles.hotelSection}>
                  {(
                    selectedSearchHotel ||
                    (selectedCity && filteredHotels.length > 0)
                  ) ? (
                    <>
                      <div className={styles.hotelViewHeader}>
                        <div>
                          <h2>
                            {selectedSearchHotel
                              ? selectedSearchHotel.name
                              : `Hotels in ${selectedCity}`}
                          </h2>

                          <span>
                            {displayedHotels.length}{" "}
                            {displayedHotels.length === 1
                              ? "Hotel"
                              : "Hotels"}
                          </span>
                        </div>

                        <HotelViewToggle
                          viewMode={hotelViewMode}
                          onChange={setHotelViewMode}
                        />
                      </div>

                      {/* Clear specific hotel selection */}
                      {selectedSearchHotel && (
                        <button
                          type="button"
                          onClick={handleClearSearchHotel}
                          className={styles.clearHotelSelection}
                        >
                          <span aria-hidden="true">×</span>
                          Show all hotels in {selectedCity || selectedState || "selected location"}
                        </button>
                      )}

                      {hotelViewMode === "grid" && (
                        <HotelGrid
                          hotels={displayedHotels}
                          comparisonHotels={comparisonHotels}
                          setComparisonHotels={setComparisonHotels}
                        />
                      )}

                      {hotelViewMode === "list" && (
                        <HotelList
                          hotels={displayedHotels}
                          comparisonHotels={comparisonHotels}
                          setComparisonHotels={setComparisonHotels}
                        />
                      )}

                      {hotelViewMode === "map" && (
                        <HotelMap
                          hotels={displayedHotels}
                          comparisonHotels={comparisonHotels}
                          setComparisonHotels={setComparisonHotels}
                        />
                      )}
                    </>
                  ) : (
                    <EmptyState />
                  )}
                </section>
              </section>
            )}

            {/* Compare Hotels */}
            {activeSection === "compare" && (
              <section
                id="compare"
                className={styles.compareSection}
              >
                <HotelComparison
                  hotels={hotels}
                  selectedHotels={comparisonHotels}
                  setSelectedHotels={setComparisonHotels}
                />
              </section>
            )}
          </section>

          <section className={styles.body}>
            <CTASection
              heading="Can't Find the Right Venue?"
              description="Tell us your event requirements, preferred location, and guest count. Our venue experts will shortlist the best hotels and ballrooms tailored to your event."
              buttonText="Speak to Our MICE Expert"
              buttonLink="/contact"
            />
  
   
    
     <section id="hotelsuggestions">
           <HotelSuggestionForm />         
    </section> 
            <section id="mice-highlights">
              <MiceHighlights />
            </section>

            {/* <FAQSection
              mainCategory="event"
              subcategory="Hotels"
              showSearch={true}
            /> */}
          </section>
        </>
      )}
    </main>
  );
}
